import { createFileRoute } from '@tanstack/react-router'
import ChecksSettings from '@/pages/settings/checks'

export const Route = createFileRoute(
  '/(protected)/settings/checks'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <ChecksSettings />
}
